var map = {
	"./icon_loading_comp.png": 6705,
	"./icon_loading_comp1.png": 3452,
	"./icon_loading_comp2.png": 6103,
	"./icon_loading_comp3.png": 3614,
	"./icon_loading_comp4.png": 9086,
	"./icon_loading_comp5.png": 6488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6714;